import { lazy, Suspense, useState } from 'react';

import { CoordinateSearch } from './CoordinateSearch';

type SearchTab = {
  type: string;
  component: JSX.Element;
};
export interface SearchComponentProps {
  close: () => void;
}

const ParcelSearch = lazy(() => import('./ParcelSearch'));

export function AdvancedSearch({ close }: SearchComponentProps) {
  const searchTabs: Array<SearchTab> = [
    {
      type: 'Parcel',
      component: (
        <Suspense fallback={<div>Error loading search...</div>}>
          <ParcelSearch close={close} />{' '}
        </Suspense>
      ),
    },
    {
      type: 'Coordinates',
      component: <CoordinateSearch close={close} />,
    },
  ];

  const [activeTab, setActiveTab] = useState(searchTabs[0]);

  const handleActiveTab = (tab: SearchTab) => {
    setActiveTab(tab);
  };

  return (
    <div className="flex min-h-[200px] min-w-[300px] flex-col gap-4">
      <div className="flex flex-row items-center space-x-4">
        {searchTabs.map((tab) => (
          <div
            className={`text-md cursor-pointer ${
              activeTab.type === tab.type ? 'font-bold underline underline-offset-8' : ''
            }`}
            key={tab.type}
            onClick={() => handleActiveTab(tab)}
          >
            {tab.type}
          </div>
        ))}
      </div>
      {activeTab?.component}
    </div>
  );
}
